import { add_expense_code_form_textfield } from 'components/ExpenseCode/constants';
import FormContainer from 'components/Forms/FormContainer';
import { TextField } from 'components/TextField';
import { FormikHelpers, FormikProps } from 'formik';
import { ExpenseCodePayload } from 'services/api';

import {
  ExpenseCodeFormValues,
  ExpenseCodeValidationSchema
} from './validation';

type ExpenseCodePayloadType = {
  initialValues: ExpenseCodeValuesType;
  handleSubmit: (
    values: ExpenseCodeValuesType,
    actions: FormikHelpers<ExpenseCodeValuesType>
  ) => void;
  actions: (props: FormikProps<ExpenseCodeValuesType>) => JSX.Element;
};

export type ExpenseCodeValuesType = ExpenseCodePayload & {
  reset?: boolean;
};

export const ExpenseCodeForm = ({
  initialValues,
  handleSubmit,
  actions,
  detailFormRef
}: ExpenseCodePayloadType & {
  detailFormRef: React.RefObject<FormikProps<ExpenseCodeValuesType>>;
}) => {
  return (
    <div style={{ paddingTop: 5 }}>
      <FormContainer
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={ExpenseCodeValidationSchema}
        buttons={actions}
        formRef={detailFormRef}
      >
        {({
          values,
          handleChange,
          errors,
          touched
        }: FormikProps<ExpenseCodeFormValues>) => (
          <>
            <TextField
              id="name"
              name="name"
              label={add_expense_code_form_textfield}
              onChange={handleChange}
              value={values.name}
              error={touched.name && errors.name ? true : false}
              helperText={touched.name && errors.name}
              fullWidth
              sx={{
                '& .MuiFormHelperText-root': {
                  textAlign: 'right'
                }
              }}
            />
          </>
        )}
      </FormContainer>
    </div>
  );
};
